import React from 'react';

//styles 
import styles from "./Loading.module.scss";

const Loading = () => {

    return (

        <div className={styles.divLoading}>

            <div className="spinner-border text-danger" role="status">

            </div>

        </div>
    );
};

export default Loading;